'use client';

import i18next from 'i18next';
import {useMemo} from 'react';
import resourcesToBackend from 'i18next-resources-to-backend';
import LanguageDetector from 'i18next-browser-languagedetector';
import {initReactI18next, I18nextProvider as Provider} from 'react-i18next';

import {cookieName, i18nOptions} from './config-locales';
import Cookies from 'js-cookie';

// ----------------------------------------------------------------------

let lng = Cookies.get(cookieName)

const init = {...i18nOptions(lng), detection: {caches: ['cookie']}};

i18next
    .use(LanguageDetector)
    .use(initReactI18next)
    .use(resourcesToBackend((lang, ns) => import(`./langs/${lang}.json`)))
    .init(init);

// ----------------------------------------------------------------------

export function I18nProvider({children}) {
    useMemo(() => {
        if (lng) {
            i18next.changeLanguage(lng);
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);

    return <Provider i18n={i18next}>{children}</Provider>;
}
